"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropsTable = _interopRequireDefault(require("./PropsTable"));

var ComponentDoc =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(ComponentDoc, _PureComponent);

  function ComponentDoc() {
    (0, _classCallCheck2["default"])(this, ComponentDoc);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ComponentDoc).apply(this, arguments));
  }

  (0, _createClass2["default"])(ComponentDoc, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          demoName = _this$props.demoName,
          propInfos = _this$props.propInfos,
          remarks = _this$props.remarks,
          children = _this$props.children;
      return _react["default"].createElement("div", null, _react["default"].createElement("a", {
        name: name
      }), _react["default"].createElement("div", {
        className: "row",
        style: {
          paddingBottom: '10px'
        }
      }, _react["default"].createElement("div", {
        className: "col-md-12"
      }, _react["default"].createElement("h2", null, name), propInfos.length ? _react["default"].createElement(_PropsTable["default"], {
        propInfos: propInfos
      }) : null, _react["default"].createElement("div", null, remarks))), children ? _react["default"].createElement("div", {
        className: "row",
        style: {
          paddingBottom: '30px'
        }
      }, _react["default"].createElement("div", {
        className: "col-md-12"
      }, _react["default"].createElement("h3", null, demoName), children)) : null);
    }
  }]);
  return ComponentDoc;
}(_react.PureComponent);

exports["default"] = ComponentDoc;
ComponentDoc.propTypes = {
  name: _propTypes["default"].string.isRequired,
  demoName: _propTypes["default"].string,
  propInfos: _propTypes["default"].arrayOf(_propTypes["default"].node),
  remarks: _propTypes["default"].element,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)])
};
ComponentDoc.defaultProps = {
  propInfos: [],
  demoName: 'Demo'
};